export const calendarI18n = [
  {
    key: 'previous-month',
    de: 'Vorheriger Monat',
    en: 'Previous month',
    it: 'Mese precedente',
    fr: 'Mois précédent',
    nl: 'Vorige maand',
  },
  {
    key: 'next-month',
    de: 'Nächster Monat',
    en: 'Next month',
    it: 'Il prossimo mese',
    fr: 'Mois suivant',
    nl: 'Volgende maand',
  },
  {
    key: 'close-calendar',
    de: 'Kalender schließen',
    en: 'Close calendar',
    it: 'Chiudi il calendario',
    fr: 'Fermer le calendrier',
    nl: 'Sluit kalender',
  }
];
//# sourceMappingURL=calendar-i18n.js.map
